/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AllocationType } from './AllocationType';
import {
    AllocationTypeFromJSON,
    AllocationTypeFromJSONTyped,
    AllocationTypeToJSON,
} from './AllocationType';

/**
 * 
 * @export
 * @interface TargetAllocationOutput
 */
export interface TargetAllocationOutput {
    /**
     * 
     * @type {string}
     * @memberof TargetAllocationOutput
     */
    accountGuid: string;
    /**
     * 
     * @type {AllocationType}
     * @memberof TargetAllocationOutput
     */
    allocationType: AllocationType;
    /**
     * 
     * @type {string}
     * @memberof TargetAllocationOutput
     */
    strategyName: string;
    /**
     * 
     * @type {number}
     * @memberof TargetAllocationOutput
     */
    targetExposure: number;
}

/**
 * Check if a given object implements the TargetAllocationOutput interface.
 */
export function instanceOfTargetAllocationOutput(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "accountGuid" in value;
    isInstance = isInstance && "allocationType" in value;
    isInstance = isInstance && "strategyName" in value;
    isInstance = isInstance && "targetExposure" in value;

    return isInstance;
}

export function TargetAllocationOutputFromJSON(json: any): TargetAllocationOutput {
    return TargetAllocationOutputFromJSONTyped(json, false);
}

export function TargetAllocationOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): TargetAllocationOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'accountGuid': json['account_guid'],
        'allocationType': AllocationTypeFromJSON(json['allocation_type']),
        'strategyName': json['strategy_name'],
        'targetExposure': json['target_exposure'],
    };
}

export function TargetAllocationOutputToJSON(value?: TargetAllocationOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'account_guid': value.accountGuid,
        'allocation_type': AllocationTypeToJSON(value.allocationType),
        'strategy_name': value.strategyName,
        'target_exposure': value.targetExposure,
    };
}

